import { useState, useEffect, useCallback } from 'react';
import { useApi } from './useApi';

export interface ExportsData {
  exportsUsed: number;
  exportsMax: number;
  resetAt: string;
  resetLabel: string;
  tier: string;
  hourlyUsed: number;
  hourlyMax: number;
}

const EMPTY: ExportsData = {
  exportsUsed: 0,
  exportsMax: 5,
  resetAt: '',
  resetLabel: 'Resets Monday',
  tier: 'free',
  hourlyUsed: 0,
  hourlyMax: 3,
};

export function useExports() {
  const { apiFetch, isAuthenticated } = useApi();
  const [data, setData] = useState<ExportsData>(EMPTY);
  const [isLoading, setIsLoading] = useState(false);

  const refresh = useCallback(async () => {
    if (!isAuthenticated) return;
    setIsLoading(true);
    try {
      const res = await apiFetch<ExportsData>('/api/user/exports');
      setData(res);
    } catch {
      // silent — fallback to defaults
    } finally {
      setIsLoading(false);
    }
  }, [apiFetch, isAuthenticated]);

  useEffect(() => {
    if (isAuthenticated) {
      refresh();
    } else {
      setData(EMPTY);
    }
  }, [isAuthenticated, refresh]);

  return { ...data, isLoading, refresh };
}
